// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.filterPanel__Pj4Un {
  margin-bottom: 25px;
  background-color: var(--tables-primary-row-surface-default);
  box-shadow: var(--basic-box-shadow);
  z-index: 1;
}
@media (max-width: 810px) {
  .filterPanel__Pj4Un {
    margin-bottom: 15px;
  }
}

.filter__VDuby {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 25px;
  border-bottom: 1px solid var(--header-stroke);
}

.sensorsOverviewFilter__I5pad {
  display: grid;
  grid-template-columns: auto 200px 200px 30px;
  align-items: flex-end;
  gap: 10px;
}
@media (max-width: 1200px) {
  .sensorsOverviewFilter__I5pad {
    grid-template-columns: 1fr 35px 30px;
    align-items: flex-end;
  }
}

.additionalShow__ZFJwy {
  display: contents;
}
@media (max-width: 1200px) {
  .additionalShow__ZFJwy {
    display: none;
  }
}

.additionalFilters__tLieU {
  display: none;
}
@media (max-width: 1200px) {
  .additionalFilters__tLieU {
    display: block;
  }
}

.switchBlock__MpGY7 {
  padding-bottom: 11px;
}

.iconContainer__xobDE {
  width: 35px;
  height: 35px;
  border-radius: 2px;
  background-color: var(--segments-chips-toggle-surface-default);
  display: none;
  align-items: center;
  justify-content: center;
  fill: var(--segments-chips-toggle-text-default);
  cursor: pointer;
}
@media (max-width: 1200px) {
  .iconContainer__xobDE {
    display: flex;
  }
}

.active__ZAQ4q {
  background-color: var(--segments-chips-toggle-surface-active);
  fill: var(--segments-chips-toggle-text-active);
}
.active__ZAQ4q .searchIcon__HwWdF path {
  stroke: var(--segments-chips-toggle-text-active);
}
.active__ZAQ4q .threeDotsIcon__TUiZw circle {
  fill: var(--segments-chips-toggle-text-active);
}

.hasChanges__QNcqv {
  position: relative;
}
.hasChanges__QNcqv:after {
  content: "";
  position: absolute;
  top: -2px;
  right: -2px;
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: #3c97aa;
}

.switcherBlock__v540V {
  display: flex;
}

.switchItem__kjbnX {
  width: 35px;
  height: 35px;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--segments-chips-toggle-surface-default);
  cursor: pointer;
}

.switchItemActive__k3b3p {
  background-color: var(--segments-chips-toggle-surface-active);
}

.switchLegendsActive__ztHx9 {
  background-color: var(--segments-chips-toggle-surface-active);
}
.switchLegendsActive__ztHx9 > svg > path {
  fill: var(--segments-chips-toggle-text-active);
}

.switchSearchActive__ILxdg {
  background-color: var(--segments-chips-toggle-surface-active);
}
.switchSearchActive__ILxdg > svg > path {
  stroke: var(--segments-chips-toggle-text-active);
}

.legendsLabel___y3K4 {
  font-size: 11px;
  line-height: 13px;
  color: var(--title-inputs-sections-title);
  text-transform: uppercase;
  white-space: nowrap;
}

.legendsBlock__wfm_8 {
  min-height: 45px;
  display: flex;
  align-items: center;
  column-gap: 55px;
  padding: 13px 25px;
}
@media (max-width: 1000px) {
  .legendsBlock__wfm_8 {
    min-height: 75px;
  }
}

.legendList___w0ZO {
  width: 100%;
  max-width: 800px;
  display: flex;
  align-items: center;
  column-gap: 25px;
}
@media (max-width: 1000px) {
  .legendList___w0ZO {
    flex-wrap: wrap;
    gap: 15px;
  }
}

.legendItem__O42Rc {
  display: flex;
  align-items: center;
}
@media (max-width: 768px) {
  .legendItem__O42Rc {
    width: 150px;
    padding-bottom: 5px;
  }
}
@media (max-width: 415px) {
  .legendItem__O42Rc {
    width: 100px;
  }
}

.legendItemIcon___aMXX {
  width: 16px;
  height: 16px;
  margin-right: 8px;
}
@media (max-width: 800px) {
  .legendItemIcon___aMXX {
    margin-right: 5px;
  }
}

.critical__GqePK {
  background-color: var(--legend-for-header-critical);
}

.high__Nmfyj {
  background-color: var(--legend-for-header-high);
}

.standard__dUyEH {
  background-color: var(--legend-for-header-standard);
}

.noAi__wt86s {
  background-color: var(--legend-for-header-no-ai);
}

.inactive__GrOTb {
  background-color: var(--legend-for-header-inactive);
  border: 1px solid var(--legend-for-header-inactive-stroke);
}

.onHold__SoRgC {
  background-color: var(--legend-for-header-snoozed);
  position: relative;
}
.onHold__SoRgC:after {
  content: "";
  position: absolute;
  top: -2px;
  right: -2px;
  width: 5px;
  height: 5px;
  background-color: var(--legend-for-header-snoozed-badge);
  border-radius: 50%;
  border: 2px solid var(--legend-for-header-snoozed-badge-stroke);
}

.legendItemName__XVFA6 {
  font-size: 10px;
  line-height: 12px;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: var(--title-inputs-sections-title);
}

.searchBlock__moNGs {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0px 25px;
  height: 45px;
  background-color: var(--header-surface);
}`, "",{"version":3,"sources":["webpack://./../src/pages/Sensors/components/FilterPanel/style.module.scss"],"names":[],"mappings":"AA0EA;EACE,mBAAA;EACA,2DAAA;EACA,mCAAA;EACA,UAAA;AAzEF;AA2EE;EANF;IAOI,mBAAA;EAxEF;AACF;;AA2EA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,6CAAA;AAxEF;;AA2EA;EACE,aAAA;EACA,4CAAA;EACA,qBAAA;EACA,SAAA;AAxEF;AA0EE;EANF;IAOI,oCAAA;IACA,qBAAA;EAvEF;AACF;;AA0EA;EACE,iBAAA;AAvEF;AAyEE;EAHF;IAII,aAAA;EAtEF;AACF;;AAyEA;EACE,aAAA;AAtEF;AAwEE;EAHF;IAII,cAAA;EArEF;AACF;;AAwEA;EACE,oBAAA;AArEF;;AAwEA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,8DAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,+CAAA;EACA,eAAA;AArEF;AAuEE;EAXF;IAYI,aAAA;EApEF;AACF;;AAuEA;EACE,6DAAA;EACA,8CAAA;AApEF;AAuEI;EACE,gDAAA;AArEN;AAyEI;EACE,8CAAA;AAvEN;;AA4EA;EACE,kBAAA;AAzEF;AA2EE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,mBAAA;AAzEJ;;AA6EA;EACE,aAAA;AA1EF;;AA6EA;EACE,WAAA;EACA,YAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,8DAAA;EACA,eAAA;AA1EF;;AA6EA;EACE,6DAAA;AA1EF;;AA6EA;EACE,6DAAA;AA1EF;AA2EE;EACE,8CAAA;AAzEJ;;AA6EA;EACE,6DAAA;AA1EF;AA4EE;EACE,gDAAA;AA1EJ;;AA8EA;EACE,eAAA;EACA,iBAAA;EACA,yCAAA;EACA,yBAAA;EACA,mBAAA;AA3EF;;AA8EA;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;EACA,kBAAA;AA3EF;AA6EE;EAPF;IAQI,gBAAA;EA1EF;AACF;;AA6EA;EACE,WAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,gBAAA;AA1EF;AA4EE;EAPF;IAQI,eAAA;IACA,SAAA;EAzEF;AACF;;AA4EA;EACE,aAAA;EACA,mBAAA;AAzEF;AA2EE;EAJF;IAKI,YAAA;IACA,mBAAA;EAxEF;AACF;AAyEE;EARF;IASI,YAAA;EAtEF;AACF;;AAyEA;EACE,WAAA;EACA,YAAA;EACA,iBAAA;AAtEF;AAwEE;EALF;IAMI,iBAAA;EArEF;AACF;;AAwEA;EACE,mDAAA;AArEF;;AAwEA;EACE,+CAAA;AArEF;;AAwEA;EACE,mDAAA;AArEF;;AAwEA;EACE,gDAAA;AArEF;;AAwEA;EACE,mDAAA;EACA,0DAAA;AArEF;;AAwEA;EACE,kDAAA;EACA,kBAAA;AArEF;AAuEE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;EACA,wDAAA;EACA,kBAAA;EACA,+DAAA;AArEJ;;AAyEA;EACE,eAAA;EACA,iBAAA;EACA,sBAAA;EACA,yBAAA;EACA,yCAAA;AAtEF;;AAyEA;EACE,WAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,iBAAA;EACA,YAAA;EACA,uCAAA;AAtEF","sourcesContent":["%scrollbar-style {\n  scrollbar-color: rgba(0, 0, 0, 0.2) rgba(0, 0, 0, 0.05);\n  scrollbar-width: auto;\n\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n@mixin scrollBar {\n  &::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-track {\n    background: rgba(0, 0, 0, 0.05);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb {\n    background: rgba(0, 0, 0, 0.2);\n    border-radius: 3px;\n  }\n\n  &::-webkit-scrollbar-thumb:hover {\n    background: #888;\n    border-radius: 3px;\n  }\n}\n\n@mixin ellipsis-text {\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: pre-wrap;\n  word-wrap: break-word;\n  display: -webkit-box;\n  -webkit-box-orient: vertical;\n}\n\n@mixin tooltip {\n  padding: 8px !important;\n  opacity: 1 !important;\n  filter: drop-shadow(0 0 1px rgba(12, 26, 75, 0.24));\n  border-radius: 4px !important;\n  text-align: left !important;\n}\n\n@mixin modalTitle {\n  color: var(--header-title-main);\n  font-size: 18px;\n  font-style: normal;\n  font-weight: 500;\n  line-height: 20px;\n  text-transform: uppercase;\n}\n\n.filterPanel {\n  margin-bottom: 25px;\n  background-color: var(--tables-primary-row-surface-default);\n  box-shadow: var(--basic-box-shadow);\n  z-index: 1;\n\n  @media (max-width: 810px) {\n    margin-bottom: 15px;\n  }\n}\n\n.filter {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 15px 25px;\n  border-bottom: 1px solid var(--header-stroke);\n}\n\n.sensorsOverviewFilter {\n  display: grid;\n  grid-template-columns: auto 200px 200px 30px;\n  align-items: flex-end;\n  gap: 10px;\n\n  @media (max-width: 1200px) {\n    grid-template-columns: 1fr 35px 30px;\n    align-items: flex-end;\n  }\n}\n\n.additionalShow {\n  display: contents;\n\n  @media (max-width: 1200px) {\n    display: none;\n  }\n}\n\n.additionalFilters {\n  display: none;\n\n  @media (max-width: 1200px) {\n    display: block;\n  }\n}\n\n.switchBlock {\n  padding-bottom: 11px;\n}\n\n.iconContainer {\n  width: 35px;\n  height: 35px;\n  border-radius: 2px;\n  background-color: var(--segments-chips-toggle-surface-default);\n  display: none;\n  align-items: center;\n  justify-content: center;\n  fill: var(--segments-chips-toggle-text-default);\n  cursor: pointer;\n\n  @media (max-width: 1200px) {\n    display: flex;\n  }\n}\n\n.active {\n  background-color: var(--segments-chips-toggle-surface-active);\n  fill: var(--segments-chips-toggle-text-active);\n\n  .searchIcon {\n    path {\n      stroke: var(--segments-chips-toggle-text-active);\n    }\n  }\n  .threeDotsIcon {\n    circle {\n      fill: var(--segments-chips-toggle-text-active);\n    }\n  }\n}\n\n.hasChanges {\n  position: relative;\n\n  &:after {\n    content: '';\n    position: absolute;\n    top: -2px;\n    right: -2px;\n    width: 5px;\n    height: 5px;\n    border-radius: 50%;\n    background: #3c97aa;\n  }\n}\n\n.switcherBlock {\n  display: flex;\n}\n\n.switchItem {\n  width: 35px;\n  height: 35px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background-color: var(--segments-chips-toggle-surface-default);\n  cursor: pointer;\n}\n\n.switchItemActive {\n  background-color: var(--segments-chips-toggle-surface-active);\n}\n\n.switchLegendsActive {\n  background-color: var(--segments-chips-toggle-surface-active);\n  & > svg > path {\n    fill: var(--segments-chips-toggle-text-active);\n  }\n}\n\n.switchSearchActive {\n  background-color: var(--segments-chips-toggle-surface-active);\n\n  & > svg > path {\n    stroke: var(--segments-chips-toggle-text-active);\n  }\n}\n\n.legendsLabel {\n  font-size: 11px;\n  line-height: 13px;\n  color: var(--title-inputs-sections-title);\n  text-transform: uppercase;\n  white-space: nowrap;\n}\n\n.legendsBlock {\n  min-height: 45px;\n  display: flex;\n  align-items: center;\n  column-gap: 55px;\n  padding: 13px 25px;\n\n  @media (max-width: 1000px) {\n    min-height: 75px;\n  }\n}\n\n.legendList {\n  width: 100%;\n  max-width: 800px;\n  display: flex;\n  align-items: center;\n  column-gap: 25px;\n\n  @media (max-width: 1000px) {\n    flex-wrap: wrap;\n    gap: 15px;\n  }\n}\n\n.legendItem {\n  display: flex;\n  align-items: center;\n\n  @media (max-width: 768px) {\n    width: 150px;\n    padding-bottom: 5px;\n  }\n  @media (max-width: 415px) {\n    width: 100px;\n  }\n}\n\n.legendItemIcon {\n  width: 16px;\n  height: 16px;\n  margin-right: 8px;\n\n  @media (max-width: 800px) {\n    margin-right: 5px;\n  }\n}\n\n.critical {\n  background-color: var(--legend-for-header-critical);\n}\n\n.high {\n  background-color: var(--legend-for-header-high);\n}\n\n.standard {\n  background-color: var(--legend-for-header-standard);\n}\n\n.noAi {\n  background-color: var(--legend-for-header-no-ai);\n}\n\n.inactive {\n  background-color: var(--legend-for-header-inactive);\n  border: 1px solid var(--legend-for-header-inactive-stroke);\n}\n\n.onHold {\n  background-color: var(--legend-for-header-snoozed);\n  position: relative;\n\n  &:after {\n    content: '';\n    position: absolute;\n    top: -2px;\n    right: -2px;\n    width: 5px;\n    height: 5px;\n    background-color: var(--legend-for-header-snoozed-badge);\n    border-radius: 50%;\n    border: 2px solid var(--legend-for-header-snoozed-badge-stroke);\n  }\n}\n\n.legendItemName {\n  font-size: 10px;\n  line-height: 12px;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n  color: var(--title-inputs-sections-title);\n}\n\n.searchBlock {\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0px 25px;\n  height: 45px;\n  background-color: var(--header-surface);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"filterPanel": `filterPanel__Pj4Un`,
	"filter": `filter__VDuby`,
	"sensorsOverviewFilter": `sensorsOverviewFilter__I5pad`,
	"additionalShow": `additionalShow__ZFJwy`,
	"additionalFilters": `additionalFilters__tLieU`,
	"switchBlock": `switchBlock__MpGY7`,
	"iconContainer": `iconContainer__xobDE`,
	"active": `active__ZAQ4q`,
	"searchIcon": `searchIcon__HwWdF`,
	"threeDotsIcon": `threeDotsIcon__TUiZw`,
	"hasChanges": `hasChanges__QNcqv`,
	"switcherBlock": `switcherBlock__v540V`,
	"switchItem": `switchItem__kjbnX`,
	"switchItemActive": `switchItemActive__k3b3p`,
	"switchLegendsActive": `switchLegendsActive__ztHx9`,
	"switchSearchActive": `switchSearchActive__ILxdg`,
	"legendsLabel": `legendsLabel___y3K4`,
	"legendsBlock": `legendsBlock__wfm_8`,
	"legendList": `legendList___w0ZO`,
	"legendItem": `legendItem__O42Rc`,
	"legendItemIcon": `legendItemIcon___aMXX`,
	"critical": `critical__GqePK`,
	"high": `high__Nmfyj`,
	"standard": `standard__dUyEH`,
	"noAi": `noAi__wt86s`,
	"inactive": `inactive__GrOTb`,
	"onHold": `onHold__SoRgC`,
	"legendItemName": `legendItemName__XVFA6`,
	"searchBlock": `searchBlock__moNGs`
};
module.exports = ___CSS_LOADER_EXPORT___;
